<template>
  <div class="news-card">
    <div class="top-circles">
      <img :src="item.image1" class="circle-image" />
      <img
        v-if="item.image2"
        :src="item.image2"
        class="circle-user-pic overlapped"
      />
    </div>
    <div class="horizontal-box-content">
      <span class="title">{{ item.title }}</span>
      <span class="description">{{ item.message }}</span>
    </div>
    <div class="reactions">
      <span
        class="reaction"
        v-for="(count, emoji) in formattedReactions"
        :key="emoji"
      >
        <span @click="addReaction(emoji)" @mousedown="animateReaction($event)">
          {{ emoji }} ({{ count }})
        </span>
       <!--  <button v-if="count > 0" @click="deleteReaction(emoji)" class="delete-btn">❌</button> -->
      </span>
    </div>
  </div>
</template>

<script>
import ApiService from '../../common/service.api';

export default {
  name: "NewsCard",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      localReactions: this.formatReactions(this.item.reactions),
    };
  },
  computed: {
    formattedReactions() {
      return this.localReactions;
    }
  },
  methods: {
    formatReactions(reactions) {
      const reactionCount = {};
      reactions.forEach(reaction => {
        const emoji = this.getReactionEmoji(reaction.type);
        if (emoji) {
          reactionCount[emoji] = (reactionCount[emoji] || 0) + 1;
        }
      });
      return reactionCount;
    },


    getReactionEmoji(reactionType) {
      const reactionEmojis = {
        "like": "👍",
        "love": "❤️",
        "happiness": "😆",
        "sad": "😢",
        "surprise": "😮",
      };
      return reactionEmojis[reactionType] || null;
    },

    async addReaction(emoji) {
      try {
        const reactionType = this.getReactionType(emoji); 
        const payload = {
          idPost: this.item.id,
          idUser: this.item.idUser,
          type: reactionType,
          user: this.item.user,
          eventDate: new Date().toISOString(),
        };

        await ApiService.post("SocialPost/AddReaction", payload);
    

        this.localReactions[emoji] = (this.localReactions[emoji] || 0) + 1;

        this.$emit("update-reactions", { ...this.localReactions });

      } catch (error) {
        console.error("Error", error);
      }
    },

/*     async deleteReaction(emoji) {
      try {
        const reactionType = this.getReactionType(emoji);
        await ApiService.delete(`SocialPost/DeleteReaction/${this.item.id}`);

        console.log("Reacción eliminada correctamente");

        if (this.localReactions[emoji] > 0) {
          this.localReactions[emoji]--;
        }

        this.$emit("update-reactions", { ...this.localReactions });

      } catch (error) {
        console.error("Error al eliminar la reacción:", error);
      }
    }, */

    animateReaction(event) {
      const reactionSpan = event.target;
      reactionSpan.classList.add("reaction-clicked");
      setTimeout(() => {
        reactionSpan.classList.remove("reaction-clicked");
      }, 500);
    },

    getReactionType(emoji) {
      const emojiToType = {
        "👍": "like",
        "❤️": "love",
        "😆": "happiness",
        "😢": "sad",
        "😮": "surprise",
      };
      return emojiToType[emoji] || null;
    },
  },
};
</script>

<style scoped>
.news-card {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 350px;
  height: 170px;
  margin: 0px 15px;
  border: 1px solid #ccc;
  border-radius: 15px;
  margin-bottom: 30px;
  background-color: var(--ion-color-primary);
  color: var(--text-color-light);
  overflow: visible;
}

.top-circles {
  position: relative;
  display: flex;
  justify-content: center;
  margin: -30px 0 -20px 0;
}

.circle-image,
.circle-user-pic {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  border: 2px solid white;
  object-fit: cover;
  z-index: 100;
}

.circle-user-pic.overlapped {
  margin-left: -20px;
  z-index: 200;
}

.horizontal-box-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 30px 10px 10px;
}

.title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 5px;
}

.description {
  font-size: 10px;
  margin-bottom: 0;
}

.reactions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  padding: 0 10px;
  background-color: var(--ion-color-light);
  min-height: 35px;
  height: auto;
}

.reaction {
  font-size: 14px;
  margin: 0 5px;
  cursor: pointer;
}

.delete-btn {
  background: none;
  border: none;
  color: red;
  cursor: pointer;
  font-size: 14px;
  margin-left: 5px;
}

/* Animación para el clic en la reacción */
.reaction-clicked {
  animation: pulse-animation 0.5s ease-in-out;
}

@keyframes pulse-animation {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}
</style>
